import React, { useState } from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import "./ComparisonMatrix.css";

function ComparisonMatrix({ data }) {
  // FIX: Hooks must be defined BEFORE any early returns
  const [selectedIndices, setSelectedIndices] = useState([0, 1, 2]);

  // Early return if data is invalid
  if (!data || !data.categories || !data.countries) return null;

  const { categories, countries } = data;

  // Handle Toggle
  const toggleCountry = (idx) => {
    if (selectedIndices.includes(idx)) {
      if (selectedIndices.length > 1) {
        // Must have at least 1
        setSelectedIndices(selectedIndices.filter((i) => i !== idx));
      }
    } else {
      if (selectedIndices.length < 5) {
        // Limit to 5
        setSelectedIndices([...selectedIndices, idx]);
      }
    }
  };

  // Transform data for Recharts Radar based on SELECTION
  const radarData = categories.map((category, idx) => {
    const dataPoint = { category };
    countries.forEach((country, cIdx) => {
      if (selectedIndices.includes(cIdx)) {
        dataPoint[country.name] = country.values[idx];
      }
    });
    return dataPoint;
  });

  const colors = [
    "#22d3ee",
    "#a855f7",
    "#f43f5e",
    "#fbbf24",
    "#ffffff",
    "#4ade80",
    "#60a5fa",
  ];

  return (
    <div className="comparison-matrix">
      <div className="radar-container">
        <ResponsiveContainer width="100%">
          <RadarChart cx="50%" cy="50%" outerRadius="70%" data={radarData}>
            <PolarGrid stroke="rgba(255,255,255,0.1)" />
            <PolarAngleAxis
              dataKey="category"
              tick={{ fill: "#94a3b8", fontSize: 11, fontWeight: 600 }}
            />
            <PolarRadiusAxis
              angle={90}
              domain={[0, 100]}
              tick={false}
              axisLine={false}
            />

            {countries.map((country, idx) => {
              if (!selectedIndices.includes(idx)) return null;

              return (
                <Radar
                  key={country.name}
                  name={country.name}
                  dataKey={country.name}
                  stroke={colors[idx % colors.length]}
                  fill={colors[idx % colors.length]}
                  fillOpacity={0.1}
                  strokeWidth={2}
                />
              );
            })}

            <Legend
              wrapperStyle={{
                paddingTop: "20px",
                fontFamily: "Inter, sans-serif",
                fontSize: "0.9rem",
              }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#000",
                borderColor: "rgba(255,255,255,0.2)",
                color: "#fff",
                borderRadius: "8px",
              }}
              itemStyle={{ color: "#fff" }}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>

      {/* SELECTION CONTROLS */}
      <div className="matrix-controls">
        <h4>Select Countries to Compare (Max 5)</h4>
        <div className="checkbox-grid">
          {countries.map((c, idx) => (
            <div
              key={c.name}
              className={`country-checkbox ${
                selectedIndices.includes(idx) ? "active" : ""
              }`}
              onClick={() => toggleCountry(idx)}
              style={{
                borderColor: selectedIndices.includes(idx)
                  ? colors[idx % colors.length]
                  : "rgba(255,255,255,0.1)",
              }}
            >
              <div
                className="dot"
                style={{
                  backgroundColor: selectedIndices.includes(idx)
                    ? colors[idx % colors.length]
                    : "transparent",
                }}
              ></div>
              <span>{c.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ComparisonMatrix;
